import { CloseOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { Col, Modal, Row, Form, Input, Divider, Button, Table, Empty, notification, Alert } from "antd"
import { useContext, useEffect, useState } from "react"
import apiMaestras from "../../../../api/Maestras/api-maestras";
import { InputTexto } from "../../../../components/Mascaras/InputTexto/InputTexto";
import { useModalLineaCategorias } from "../../../../hooks/useModalLineaCategorias";
import { Categoria, Categorias, LineaConvocatoria } from "../../../../models/Maestras/maestras.model";
import { ModalExitoso } from "./ModalExitoso";
import { TemplateContext } from "../../../../utils/template_context";

interface ModalLineaCategorias {
    openModal: boolean;
    setOpenModal: Function;
    isEdit: boolean;
    datos: LineaConvocatoria,
    getLineasConvocatorias: Function
}



export const ModalLineaCategorias = ({ openModal, setOpenModal, isEdit, datos, getLineasConvocatorias }: ModalLineaCategorias) => {

    const context = useContext(TemplateContext);
    const onCancel = () => {
        // if (categorias.length == 0) {
        //     return openNotification({
        //         titulo: "Error",
        //         descripcion: "Falta asociar categorías",
        //         placement: "bottomRight",
        //     });
        // }
        setOpenModal(!openModal)
        setLineaConvocatoria({
            nombre: '',
        })

        setCategorias([])


    }

    const {
        editCategoria,
        deleteCategoria,
        createCategoria,
        lineaConvocatoria,
        setLineaConvocatoria,
        categoria,
        setCategoria,
        addCategoria,
        openAlert,
        datosCategoria,
        setOpenAlert,
        categorias,
        visible,
        setVisible,
        updateCategoria,
        setDatosCategoria,
        openModalExitoso,
        setOpenModalExitoso,
        getCategoriasLinea,
        edicionAsincronaCategoria,
        cargarCategorias,
        eliminacionAsincronaCategoria,
        openNotification,
        setCategorias
    } = useModalLineaCategorias();

    useEffect(() => {
        //
        let mounted = true;
        if (isEdit) {
            if (mounted) {
                setLineaConvocatoria(datos)
                getCategoriasLinea(datos.id);
            }
        }
        return () => {
            mounted = false
        }
    }, [cargarCategorias])


    const actualizarTodo = async () => {


        if (lineaConvocatoria.nombre == '') {
            return openNotification({
                titulo: "Error",
                descripcion: "Falta el nombre de la linea",
                placement: "bottomRight",
            });
        }

        if (categorias.length == 0) {
            return openNotification({
                titulo: "Error",
                descripcion: "Falta asociar categorías",
                placement: "bottomRight",
            });
        }

        let categoriasNuevas = categorias.filter(cat => !cat.id)

        try {
            await apiMaestras.actualizarLineaConvocatoria(lineaConvocatoria);
            if (categoriasNuevas.length !== 0) {
                categoriasNuevas.forEach(async (cat) => {
                    let payload: Categorias = {
                        nombre: cat.nombre,
                        linea_convocatoria_id: lineaConvocatoria.id
                    }
                    await apiMaestras.crearCategoriasPorLinea(payload);
                });
            }
            setOpenModalExitoso(true);
        } catch (error) {
            console.log(error);
        }
    }


    const columns: any = [
        {
            title: "Categoría",
            key: "nombre",
            dataIndex: "nombre",
            //  fixed: context.device === "md"? "left": false,
            width: 2000,
        },
        {
            title: (
                <div>
                    <div className="titleAcciones">Acciones</div>
                    <div className="controls">
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Editar
                        </div>
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Eliminar
                        </div>
                    </div>
                </div>
            ),
            key: 'actions',
            width: 150,
            fixed: context.device === "lg" ? "right" : false,
            render: (datos: Categorias, record: any, index: number) => (
                <div className="controls">
                    <EditOutlined onClick={() => editCategoria(datos, index)} />
                    <DeleteOutlined onClick={() => {
                        if (isEdit) {
                            if (datos.id) {
                                eliminacionAsincronaCategoria(datos.id)
                            } else {
                                deleteCategoria(index)
                            }
                        } else {
                            deleteCategoria(index)
                        }
                    }
                    } />
                </div>
            )
        },
    ]


    return (
        <>
            <Modal
                title={
                    <>
                        {isEdit
                            ?
                            (
                                <div>Editar línea / categoría</div>

                            )
                            :
                            (
                                <div>Crear línea / categoría</div>
                            )
                        }
                    </>
                }
                width={1000}
                visible={openModal}
                onCancel={onCancel}
                footer={
                    <>
                        <Row justify="end" gutter={[24, 24]}>
                            <Col>
                                <Button
                                    className="button-blanco-radius"
                                    onClick={onCancel}
                                >
                                    Cancelar
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    className="button-azul-radius"
                                    onClick={() => {
                                        if (isEdit) {
                                            actualizarTodo();
                                        } else {
                                            createCategoria();
                                        }
                                    }}
                                >
                                    Cerrar
                                </Button>
                            </Col>
                        </Row>
                    </>
                }
            >
                <Form

                >
                    <Row>
                        <Col span={24}>
                            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                Nombre línea
                            </span>
                            <Form.Item className="no-margin" rules={[{ required: true, message: "" }]}>
                                {/* <Input value={lineaConvocatoria.nombre} onChange={(e) => setLineaConvocatoria({ ...lineaConvocatoria, nombre: e.target.value })} /> */}
                                <InputTexto
                                    name="nombre"
                                    maxLength={1000}
                                    texto={lineaConvocatoria.nombre}
                                    setTexto={setLineaConvocatoria}
                                    alltexto={lineaConvocatoria}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <div>Crear categorías</div>
                            <Divider />
                        </Col>
                        <Col span={24}>
                            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                Nombre categoría convocatoria
                            </span>
                            <Form.Item >
                                {/* <Input value={categoria.nombre} onChange={(e) => setCategoria({ nombre: e.target.value })} /> */}
                                <InputTexto
                                    name="nombre"
                                    maxLength={1000}
                                    texto={categoria.nombre}
                                    setTexto={setCategoria}
                                    alltexto={categoria}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Row justify="end">
                                <Col>
                                    <Button
                                        onClick={addCategoria}
                                        className="button-blanco-radius"
                                    >
                                        Agregar
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>

                {openAlert &&
                    <Row gutter={[24, 24]} style={{ marginBottom: '12px' }} className="alert">
                        <Col className="alert__modal">
                            Se editó con éxito "{datosCategoria.nombre}"
                        </Col>
                        <Col>
                            <CloseOutlined onClick={() => setOpenAlert(false)} />
                        </Col>
                    </Row>
                }

                <Row>
                    <Col>
                        <div>Categorías asociadas</div>
                    </Col>
                    <Col>
                        <Table
                            dataSource={categorias}
                            columns={columns}
                            locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                            style={{ borderTop: "1px solid #C4C4C4" }}
                            size="small"
                            bordered={false}
                            pagination={false}
                        />
                    </Col>
                </Row>
            </Modal>

            <Modal
                title="Editar Categoría???"
                visible={visible}
                onCancel={() => setVisible(false)}
                footer={
                    <>
                        <Row justify="end" gutter={[24, 24]}>
                            <Col>
                                <Button
                                    className="button-blanco-radius"
                                    onClick={() => setVisible(false)}
                                >
                                    Cancelar
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    className="button-azul-radius"
                                    onClick={() => {
                                        if (isEdit) {
                                            if (datosCategoria.id) {
                                                edicionAsincronaCategoria()
                                            } else {
                                                updateCategoria();
                                            }
                                        } else {
                                            updateCategoria()
                                        }
                                    }}
                                >
                                    Guardar Cambios
                                </Button>
                            </Col>
                        </Row>
                    </>
                }
                width={1000}
            >
                <Row>
                    <Col span={24}>
                        <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                            Nombre categoría
                        </span>
                        <Form.Item>
                            <InputTexto
                                name="nombre"
                                texto={datosCategoria.nombre}
                                setTexto={setDatosCategoria}
                                alltexto={datosCategoria}
                            />
                            {/* <Input value={datosCategoria.nombre} onChange={(e) => setDatosCategoria({
                                ...datosCategoria,
                                nombre: e.target.value
                            })} /> */}
                        </Form.Item>
                    </Col>
                </Row>
            </Modal>

            <ModalExitoso
                openModal={openModalExitoso}
                setOpenModal={setOpenModalExitoso}
                setOpenModalAnterior={setOpenModal}
                getLineasConvocatorias={getLineasConvocatorias}
            />
        </>
    )
}
